import { Screen, StackScreenProps } from '@rahtab/stack-navigator';
import LoadItemCard from 'components/LoadItemCard';
import type { RootStackType } from 'components/Router';
import React from 'react';

type LoadProps = StackScreenProps<RootStackType, 'VerifiedLoadInfo'>;

const VerifiedLoadInfo: React.VFC<LoadProps> = ({ route }) => {
  const data = route.params;

  return <Screen title="اطلاعات بار ورودی" renderMain={() => <LoadItemCard {...data} extended />} />;
};

export default VerifiedLoadInfo;
